export default "__VITE_ASSET__Dkd7HBBC__"